/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import mapper from './localeCurrency.analytics';
import {
  LocaleCurrencyEvents,
  LocaleCurrencyAnalyticsParams,
} from './localeCurrency.meta';

export const trackCurrencySelected = (params: LocaleCurrencyAnalyticsParams) =>
  mapper[LocaleCurrencyEvents.Currency_Selected](params);

export const trackLanguageSelected = (params: LocaleCurrencyAnalyticsParams) =>
  mapper[LocaleCurrencyEvents.Language_Selected](params);
